import "../tool.js";
/**
 * Load lifecycle:
 *  tool.setState - used by tools with more complicated state requirements. Most
 *                  tools just pass the component context to their templates,
 *                  so that's the default
 *  tool.render - by default updates the tool element with markup generated by
 *                tool template, overrid for react apps
 *  tool.bind - bind events to the tool or component here
 *  tool.unbind - unbind any events
 *
 * Update lifecycle
 *  tool.setState
 *  tool.update
 *  tool.rendered (if the component was rendered)
 *
 * General Notes
 *  - render/bind/unbind are only called on load, after that it's setcontext
 *    and update. update is
 *  - identical to render by default, but you can override it. the update
 *    lifecycle is only triggered if
 *  - another tool changes the splinter, so if your tool changes a context
 *    value, you update your view there.
 */

(function () {
  "use strict";

  Sparkle.PageBuilder.Tool({
    /**
     * @description Unique identifier for the tool component.
     */
    name: "table-builder",

    /**
     * @description The template file to use to load and render the component.
     * @see slideshow.hbs
     */
    templateId: "table-builder-editor-template",

    /**
     * @description Unique selectors from the template to control events.
     */
    selectors: {
      editButton: ".tb-edit-button",
    },

    /**
     * @name onEditButtonClick
     * @description
     *  Handle the edit table content button click event
     *   (trigger the edit modal).
     */
    onEditButtonClick: function () {
      var editDialog = new Sparkle.PageBuilder.TableBuilderDialog(
        this.component.context,
        function (context) {
          this.component.save(context);
          this.component.render();
        }.bind(this),
        {},
      );
    },

    /**
     * @name bind
     * @description
     * Bind the different event listeners to the component, and also add in
     *  any extra functionality to manage the slideshow
     * @param {HTMLElement} component
     */
    bind: function (component) {
      var me = this,
        $rootElement = jQuery(this.element);

      // attach events
      jQuery(this.element).on("click", "button", this.onEditButtonClick.bind(this));
    },

    /**
     * @name unbind
     * @description
     * Unbind the different event listeners to the component added during the
     *  initial bind step.
     * @param {HTMLElement} element
     */
    unbind: function (element) {
      jQuery(this.element).find("button").off();
    },
  });
})();
